import { render } from "./dataanalysis.vue?vue&type=template&id=7ecff805"
import script from "./dataanalysis.vue?vue&type=script&lang=js"
export * from "./dataanalysis.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__